module.exports = __webpack_public_path__ + "static/media/i18n_Project.7338b967.PNG";